/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountPlanConfig } from './accountPlanConfig';


export interface ActualAccountPlanApiModel { 
    id: number;
    tenantId: number;
    validFrom: string;
    validTo: string;
    activeEmployeesCount: number;
    planDetails: AccountPlanConfig;
    nextSubscriptionCharge?: string | null;
    nextSubscriptionPlan?: AccountPlanConfig | null;
}

